import { type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { PermissionDenied } from "@/components/permissions/permission-denied";
import { ErrorState, LoadingState } from "@/components/shared/states";
import {
  getRouteAccessRequirement,
  permissionRouteState,
} from "@/lib/route-access";
import { useAuth } from "./auth-provider";

export function PermissionRoute({ children }: { children: ReactNode }) {
  const { access, session, loading } = useAuth();
  const { pathname } = useLocation();
  const state = permissionRouteState(
    access,
    loading,
    pathname,
    session?.user.id ?? null,
  );
  if (state === "loading")
    return <LoadingState label="Checking your access..." />;
  if (state === "unavailable")
    return (
      <ErrorState
        error={
          new Error(
            "Your access profile is not available yet. Try loading your profile again.",
          )
        }
      />
    );
  const requirement = getRouteAccessRequirement(pathname);
  if (state === "denied" && requirement)
    return <PermissionDenied requirement={requirement} />;
  return <>{children}</>;
}
